import React from 'react';
import PropTypes from 'prop-types';
import * as C from '../../models/medals/constants';
import MedalTable from './MedalTable';

export default class Medals extends React.Component {
    static propTypes = {
        // eslint-disable-next-line
        answer: PropTypes.any,
        // eslint-disable-next-line
        actions: PropTypes.any,
        // eslint-disable-next-line
        limits: PropTypes.any.isRequired
    };

    constructor(props) {
        super(props);
        this.fixed_command = 'Россия';
        this.medals = [];
        this.state = {
            selected_country: '',
            selected_order: '',
            medals: [],
            use_filter: false,
            country_list: [],
            sort_type: '',
            sort_field: ''
        };

        this.updateFilter = this.updateFilter.bind(this);
        this.updateSort = this.updateSort.bind(this);
    }

    componentDidMount() {
        this.props.actions.loadMedals();
    }

    componentWillReceiveProps(props) {
        if (props.answer && props.answer.state) {
            if (props.answer.state === C.FINISH_LOAD_MEDALS) {
                const zeroValues = props.answer.data[0] || false;
                this.updateMedalsList(
                    props.answer.data[0] ? props.answer.data : props.answer.data.data,
                    zeroValues);
            }
        }
    }
    updateMedalsList(medals, zero = false) {
        if (medals && medals[0] && medals[0].data && medals[0].data.medal) {
            // for filter backup

            if (zero !== false) {
                // eslint-disable-next-line
                medals[0].data.medal.forEach((o, i) => {
                    // eslint-disable-next-line
                    medals[0].data.medal[i].first = 0;
                    // eslint-disable-next-line
                    medals[0].data.medal[i].second = 0;
                    // eslint-disable-next-line
                    medals[0].data.medal[i].third = 0;
                    // eslint-disable-next-line
                    medals[0].data.medal[i].total = 0;
                });
            }

            this.medals = medals[0].data.medal;
            this.generateMedalsList(this.medals);
            const resultCountry = [];
            medals[0].data.medal.forEach((item) => {
                if (item.code !== '' && typeof item.name !== 'undefined') {
                    resultCountry.push({ name: item.name, code: item.code });
                }
            });
            this.setState({
                country_list: resultCountry
            });
        }
    }

    generateMedalsList(medals, filterName = '', sortField = '', sortType = '') {
        let resultMedals = medals.filter(item => item.overall !== 1);
        const sf = {
            gold: 'first',
            silver: 'second',
            bronze: 'third',
            all: 'total'
        };

        if (sortField !== '' && sortType !== '') {
            const sortRevers = sortType === 'up' ? 1 : -1;
            resultMedals = resultMedals.sort((a, b) => 
                (sortRevers *
                    ((a[sf[sortField]] > b[sf[sortField]]) - (b[sf[sortField]] > a[sf[sortField]]))
                )
            );
        }

        if (this.props.limits !== 'all') {
            resultMedals = resultMedals.splice(0, this.props.limits);
            if (sortType === '' && sortField === '') {
                resultMedals = resultMedals.filter(item => (item.name !== this.fixed_command));
            }
            const fixedCommand = this.medals.filter(item => (item.name === this.fixed_command));
              
            if (fixedCommand[0] && fixedCommand[0].position && sortType === '' && sortField === '') {
                fixedCommand[0].checked = true;
                resultMedals = [...resultMedals, ...fixedCommand];
            } else {
                resultMedals.forEach((o, i) => {
                    if (o.name === this.fixed_command) {
                        resultMedals[i].checked = true;
                    }
                });
            }
        } else {
            resultMedals.forEach((o, i) => {
                if (o.name === this.fixed_command) {
                    resultMedals[i].checked = true;
                }
            });
        }
       
        if (filterName !== '') {
            resultMedals = this.medals.filter(item => (item.code === filterName));
        }

        if (sortField !== '' && sortType !== '') {
            if (sortField !== 'gold') {
                // eslint-disable-next-line
                for (let i = 0; i < resultMedals.length - 1; i ++) {
                    if (
                        resultMedals[i].first < resultMedals[i + 1].first
                        && resultMedals[i][sf[sortField]] === resultMedals[i + 1][sf[sortField]]) {
                        const buff = resultMedals[i];
                        resultMedals[i] = resultMedals[i + 1];
                        resultMedals[i + 1] = buff;
                        console.log('yep');
                    }
                }
            }
        }

        
        this.setState({
            medals: resultMedals
        });
    }

    updateSort(sortField, sortType) {
        this.setState({
            sort_type: sortType,
            sort_field: sortField
        });
        if (this.state.selected_country === '') {
            this.generateMedalsList(this.medals, '', sortField, sortType);
        }
    }

    updateFilter(e) {
        const country = (e && e.value) ? e.value : '';
        this.setState({
            selected_country: country
        });
        this.generateMedalsList(this.medals, country);
    }

    render() {
        return (
            <section className="medals">
                <MedalTable
                    updateFilter={this.updateFilter}
                    data={this.state.medals}
                    counties={this.state.country_list}
                    selected={this.state.selected_country}
                    updateSort={this.updateSort}
                    sortType={this.state.sort_type}
                    sortField={this.state.sort_field}
                />
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Medals/index.jsx